// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ESHOP_BANNER_TEXT = "Ko\u010d\u00e1rky a autoseda\u010dky";
export const PREGNANCY_NEWSLETTER_BANNER_TEXT = "Odeb\u00edrej t\u011bhotensk\u00fd newsletter! ";
export const PREGNANCY_NEWSLETTER_HINT = "Jsi t\u011bhotn\u00e1?";
export const PRODUCT_ESHOP_BADGE = "Mamaleto E-shop";
